export class ProjectFilesTreeControl {
  constructor(public buildLink: (filePath: string, branchName: string) => string | any[]) { }
}
